import { useMemo, type ComponentProps, type FC, type ReactNode } from "react";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import Keycloak from "keycloak-js";

export function createKeycloak(): Keycloak.KeycloakInstance {
  const url = process.env.REACT_APP_KEYCLOAK_URL;
  const realm = process.env.REACT_APP_KEYCLOAK_REALM;
  const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;

  if (url == null || realm == null || clientId == null) {
    throw new Error("Missing Keycloak environment configuration");
  }

  return new Keycloak({
    url,
    realm,
    clientId,
  });
}

type ProviderProps = (
  Partial<Omit<ComponentProps<typeof ReactKeycloakProvider>, "authClient" | "children">>
) & { children: ReactNode };

export const KeycloakProvider: FC<ProviderProps> = ({
  children,
  initOptions,
  ...rest
}) => {
  const keycloak = useMemo(createKeycloak, []);
  const mergedInitOptions = {
    onLoad: "check-sso" as const,
    promiseType: "native" as const,
    pkceMethod: "S256" as const,
    checkLoginIframe: false,
    ...initOptions,
  };

  return (
    <ReactKeycloakProvider authClient={keycloak} initOptions={mergedInitOptions} {...rest}>
      {children}
    </ReactKeycloakProvider>
  );
};
